export const handleErrorIntoService = async (promise: Promise<any>) => {
  try {
    return await promise;
  } catch (error) {
    if (error?.response?.status === 500)
      return {
        data: {
          message: 'Что-то пошло не так',
          errors: [
            {
              msg: 'Ошибка сервера, мы знаем о проблеме и решаем её.',
            },
          ],
        },
      };
    return error.response;
  }
};



// WEBPACK FOOTER //
// ./src/tools/handleErrorIntoService.ts